import { t } from "@/i18n-js/instance";
import { SCHEDULE_TYPE } from "../../constants";

type ScheduleType = (typeof SCHEDULE_TYPE)[keyof typeof SCHEDULE_TYPE];

interface ScheduleTypeProps {
  scheduleType: ScheduleType;
}

export const ScheduleType = ({ scheduleType }: ScheduleTypeProps) => {
  const i18nRoot = "settings.workflows.schedule_types";

  const typeMap: Record<ScheduleType, string> = {
    [SCHEDULE_TYPE.ONE_TIME]: t(`${i18nRoot}.one_time`),
    [SCHEDULE_TYPE.RECURRING]: t(`${i18nRoot}.recurring`),
  };
  return (
    <span className="flex min-h-[1.5rem] items-center gap-2">
      <span className="break-normal">{typeMap[scheduleType]}</span>
    </span>
  );
};
